import api from './api';

const recurringService = {
  list: async () => {
    const res = await api.get('/recurring-expenses');
    return res.data;
  },

  create: async (payload: any) => {
    const res = await api.post('/recurring-expenses', payload);
    return res.data;
  },

  update: async (id: string, payload: any) => {
    const res = await api.put(`/recurring-expenses/${id}`, payload);
    return res.data;
  },

  remove: async (id: string) => {
    const res = await api.delete(`/recurring-expenses/${id}`);
    return res.data;
  },

  generateLaunches: async (id: string) => {
    const res = await api.post(`/recurring-expenses/${id}/generate`, {});
    return res.data;
  },
};

export default recurringService;
